import { WizardCard } from '@mosey/components/layout/WizardCard';
import {
  useHandbookTasksSummaryForLocation,
  useRequirementTasksSummary,
  useTasksOverviewLocation,
} from '../../utils/hooks';
import { generateResolverTasksBrowserUrl } from '../../utils';
import { ResolverType } from '../../utils/types';
import {
  useIsHandbookEnabled,
  useIsHandbookPresent,
} from '../../../handbook/hooks/useIsHandbook';

export const HandbookAlert = () => {
  const location = useTasksOverviewLocation();
  const requirementTasks = useRequirementTasksSummary();
  const handbookCounts = useHandbookTasksSummaryForLocation();
  const isHandbookEnabled = useIsHandbookEnabled();
  const isHandbookPresent = useIsHandbookPresent();

  if (location) {
    if (handbookCounts !== null && handbookCounts.todo > 0) {
      const title = 'Adopt employee policies';
      const description = `Add these ${location.name} policies to your handbook to stay compliant.`;

      return (
        <WizardCard
          variant="handbook"
          title={title}
          description={description}
          aria-label={`${title} &#8211; ${description}`}
          to={
            isHandbookEnabled || isHandbookPresent
              ? '/handbook'
              : generateResolverTasksBrowserUrl({
                  locationId: location.code,
                  resolverType: ResolverType.Handbook,
                })
          }
        />
      );
    }

    return null;
  }

  const handbookRegionCount = Object.values(requirementTasks).reduce(
    (acc, { handbook_count: handbookCount }) => {
      return acc + handbookCount.todo;
    },
    0,
  );

  if (handbookRegionCount > 0) {
    const title = 'Adopt employee policies';
    const description =
      'Add these policies to your handbook to stay compliant.';

    return (
      <WizardCard
        variant="handbook"
        title={title}
        description={description}
        aria-label={`${title} &#8211; ${description}`}
        to={
          isHandbookEnabled || isHandbookPresent
            ? '/handbook'
            : generateResolverTasksBrowserUrl({
                resolverType: ResolverType.Handbook,
              })
        }
        truncate={false}
      />
    );
  }

  return null;
};
